import React from 'react'
import { observer } from 'mobx-react'

import './derived.scss'
import Typography from '../../../../UniformComponents/Typography'

const OSSChartSlot = ({ store, position, chartKey }) => {
    const slide = store.activeSlide
    const question = slide.question.get(position)
    const data = store.getChartDataForQuestion(`${question.surveyId}-OSS`, position)

    const getColorForPct = (pct) => {
        if (pct < 0.25) return '#E8555F'
        if (pct < 0.5) return '#FFC000'
        return '#4CAF50'
    }

    const handleEdit = () => {
        store.handleEditChart(position)
    }

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%' }}>
            <div className="pp-slide-controls">
                <div className="pp-slide-edit" onClick={handleEdit}>
                    <i className="fas fa-pen-to-square" />
                </div>
            </div>

            {question
                ? (
                    <>
                        {store.getChart(
                            {
                                ...data,
                                title: '',
                                containerSize: { height: 400, width: 450 },
                                chartType: 'standardColumn',
                                kpiType: 'OSS',
                                surveyId: question.surveyId,
                                surveyDefaultLocale: question.surveyDefaultLocale || data?.surveyDefaultLocale,
                                settings: question.settings,
                                key: chartKey,
                            },
                            data?.data,
                            [...question.comparisonYears, question.year],
                        )}
                        {data.ossRanks ? (
                            <div style={{ position: 'absolute', left: 20, top: '5%', display: 'flex' }}>
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <div style={{ textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#102E4A', height: 38, padding: '2px 5px' }}>
                                        <Typography type="tiny-b" style={{ color: 'white' }}>KPI</Typography>
                                    </div>
                                    <div style={{ padding: '2px 5px', border: '1px solid #ccc', height: 25, backgroundColor: 'white', textWrap: 'nowrap' }}><Typography type="tiny">Overall Satisfaction</Typography></div>
                                    <div style={{ padding: '2px 5px', border: '1px solid #ccc', height: 25, backgroundColor: 'white', textWrap: 'nowrap' }}><Typography type="tiny">Likelihood of Return</Typography></div>
                                    <div style={{ padding: '2px 5px', border: '1px solid #ccc', height: 25, backgroundColor: 'white', textWrap: 'nowrap' }}><Typography type="tiny">Net Promoter Score</Typography></div>
                                    <div style={{ padding: '2px 5px', border: '1px solid #ccc', height: 25, backgroundColor: 'white', textWrap: 'nowrap' }}><Typography type="tiny">Importance</Typography></div>
                                </div>

                                <div style={{ display: 'flex', flexDirection: 'column', textAlign: 'center' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#102E4A', height: 38, padding: '2px 5px' }}>
                                        <Typography type="tiny-b" style={{ color: 'white' }}>Weighting</Typography>
                                    </div>
                                    <div style={{ padding: '2px 5px', border: '1px solid #ccc', height: 25, backgroundColor: 'white' }}><Typography type="tiny">40%</Typography></div>
                                    <div style={{ padding: '2px 5px', border: '1px solid #ccc', height: 25, backgroundColor: 'white' }}><Typography type="tiny">20%</Typography></div>
                                    <div style={{ padding: '2px 5px', border: '1px solid #ccc', height: 25, backgroundColor: 'white' }}><Typography type="tiny">20%</Typography></div>
                                    <div style={{ padding: '2px 5px', border: '1px solid #ccc', height: 25, backgroundColor: 'white' }}><Typography type="tiny">20%</Typography></div>
                                </div>
                                {console.log('QUESTION', question, question.comparisonYears, Object.entries(data.ossRanks))}
                                {Object.entries(data.ossRanks).filter(([k, v]) => question.comparisonYears.includes(parseInt(k))).map(([k, v]) => (
                                    <div style={{ display: 'flex', flexDirection: 'column', textAlign: 'center' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#102E4A', height: 38, padding: '2px 5px', width: 100 }}>
                                            <Typography type="tiny-b" style={{ maxWidth: 100, color: 'white' }}>{`${k} Explori Rank`}</Typography>
                                        </div>
                                        <div style={{ padding: '2px 5px', border: '1px solid #ccc', height: 25, backgroundColor: 'white' }}><Typography type="tiny-b" style={{ color: getColorForPct(v.OS) }}>{`${parseInt(v.OS * 100, 10)}%`}</Typography></div>
                                        <div style={{ padding: '2px 5px', border: '1px solid #ccc', height: 25, backgroundColor: 'white' }}><Typography type="tiny-b" style={{ color: getColorForPct(v.FA) }}>{`${parseInt(v.FA * 100, 10)}%`}</Typography></div>
                                        <div style={{ padding: '2px 5px', border: '1px solid #ccc', height: 25, backgroundColor: 'white' }}><Typography type="tiny-b" style={{ color: getColorForPct(v.NPS) }}>{`${parseInt(v.NPS * 100, 10)}%`}</Typography></div>
                                        <div style={{ padding: '2px 5px', border: '1px solid #ccc', height: 25, backgroundColor: 'white' }}><Typography type="tiny-b" style={{ color: getColorForPct(v.IOV) }}>{`${parseInt(v.IOV * 100, 10)}%`}</Typography></div>
                                    </div>
                                ))}
                            </div>
                        ) : null}
                    </>
                )
                : null}
        </div>
    )
}

export default observer(OSSChartSlot)
